module.exports = global["$"] = require("-!C:\\xampp\\htdocs\\gwarant-limanowa\\gwarant-limanowa\\theme\\node_modules\\expose-loader\\index.js?jQuery!C:\\xampp\\htdocs\\gwarant-limanowa\\gwarant-limanowa\\theme\\node_modules\\jquery\\dist\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** C:/xampp/htdocs/gwarant-limanowa/gwarant-limanowa/theme/~/jquery/dist/jquery.js
 ** module id = 2
 ** module chunks = 0
 **/